<template>
  <FullscreenMediaContainer
    :video="project.hero.video"
    :image="project.hero.image"
    :horizontal-focus="toPercent(project.hero.focus[0])"
    :vertical-focus="toPercent(project.hero.focus[1])"
    @update:image-loaded="emit('update:image-loaded', $event)"
  >
    <div class="container work-hero-content">
      <div class="hero-layout">
        <FactsTable :facts="project.metadata" emphasized class="hero-layout-facts" />
      </div>

      <ScrollButton class="work-hero-scroll-button" interactive>Project</ScrollButton>
    </div>
  </FullscreenMediaContainer>
</template>

<script setup>
import { toPercent } from '@/assets/js/util'

let props = defineProps({
  project: Object,
})

let emit = defineEmits(['update:image-loaded'])
</script>

<style lang="scss" scoped>
@keyframes fade-in {
  to {
    opacity: 1;
  }
}

.work-hero-scroll-button {
  position: absolute;
  right: 5vh;
  bottom: calc(var(--bottom-offset, 0px) + 5vh);
  visibility: hidden;

  @include mediaSM {
    visibility: visible;
  }
}

.work-hero-content {
  opacity: 0;
  animation: fade-in 650ms forwards;
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 5vh;
}

@function base-size($factor: 1) {
  @return calc(#{$factor} * var(--base-size, 1rem));
}

.key-facts {
  --base-size: 12px;

  margin: 0;
  display: grid;
  width: fit-content;
  grid-template-columns: auto auto auto;
  row-gap: base-size(0.3);

  line-height: 1;

  .fact-term,
  .fact-slash,
  .fact-value {
    --padding-y-start: #{base-size(1.1)};
    --padding-y-end: #{base-size(0.9)};

    display: flex;
    align-items: center;
    padding: var(--padding-y-start, 0) var(--padding-x, 0) var(--padding-y-end, 0);
    background-color: rgb(0 0 0 / 75%);
  }

  .fact-slash {
    --padding-y-start: #{base-size(1)};
    --padding-y-end: #{base-size(1)};
    --padding-x: #{base-size(0.75)};

    --slash-size: #{base-size(1.5)};
    --slash-color: var(--primary-color);
  }

  .fact-term {
    text-transform: uppercase;
    font-size: base-size(1);
    padding-left: base-size(1);
    line-height: 0;
    letter-spacing: 2px;
  }

  .fact-value {
    margin: 0;
    text-transform: uppercase;
    font-size: base-size(1.5);
    font-weight: bold;
    color: var(--primary-color);
    padding-left: base-size(0.3);
    padding-right: base-size(2.25);
    width: fit-content;

    a {
      color: inherit;
      text-decoration: none;
    }
  }

  @include mediaSM {
    --base-size: 16px;
  }
}

.hero-layout {
  display: grid;

  .hero-layout-facts {
    grid-row: 1 / span 1;
  }
}

.hero-slash {
  margin-bottom: -0.075em;
  margin-left: 0.25em;
  white-space: pre-wrap;
  --slash-display: inline-block;
  --slash-size: 0.85em;
  --slash-color: var(--primary-color);
}
</style>
